module.exports = __webpack_public_path__ + "static/img/ic_radius_off@2x.9f555d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_radius_off@2x.png
// module id = lE8Z
// module chunks = 1